import apiService from "./apiService";
import {
  DYNAMIC_PAGE_GROUP_MONTH
} from "../../../pages/dynamicUi/constants";


export const getAllDynamicUiPages = (group, all) => {

  const params = all || !group? {}:{
    ...(group===DYNAMIC_PAGE_GROUP_MONTH && {month: true}),
    ...(group!==DYNAMIC_PAGE_GROUP_MONTH && {group}),
  };


  return apiService.get(URIS.pages, {params});
};

export const postDynamicUiPage = (data) => {
  return apiService.post(URIS.pages, data);
};

export const putDynamicUiPage = (id, data) => {
  return apiService.put(URIS_D('page', id), data);
};

export const patchDynamicUiPage = (id, data) => {
  return apiService.patch(URIS_D('page', id), data);
};

export const deleteDynamicUiPage = (id) => {
  return apiService.delete(URIS_D('page', id));
};

export const getDynamicPage = (id) => {
  return apiService.get(URIS_D('page', id));
};

export const postTabToPage = (pageId, data) => {
  return apiService.post(URIS_D("page_tabs", pageId), data);
};

export const putTabToPage = (pageId, tabId, data) => {
  return apiService.put(URIS_D("page_tab", pageId, tabId), data);
};

export const postOrPutPageTabs = (pageId, tabId, data) => {
  return tabId ? putTabToPage(pageId, tabId, data) : postTabToPage(pageId, data);
};

export const deleteTabFromPage = (pageId, tabId) => {
  return apiService.delete(URIS_D("page_tab", pageId, tabId));
};



const URIS_D = (url, param1, param2) => {
  return {

    page: `${URIS.pages}/${param1}`,
    page_tabs: `${URIS.pages}/${param1}/tabs`,
    page_tab: `${URIS.pages}/${param1}/tabs/${param2}`,
  }[url];
};

const URIS = {
  pages: '/v1/cms/pages',

};
